import React, { useEffect, useState } from "react";
import RadioButton from "../Buttons/RadioButton";
import SwitchButton from "../Buttons/SwitchButton";
import Modal from "../Common/Modal";
import SpinnerTextBox from "../Controls/SpinnerTextBox";
import "./SettingsCard.css";
import { EGraphType, TemperatureSetting } from "./TemperatureChartUtil";

type Props = {
  setting: TemperatureSetting;
  okHandler: (setting: TemperatureSetting) => void;
  cancelHandler: () => void;
};

export default function SettingsCard(props: Props) {
  const [setting, setSetting] = useState(props.setting);
  useEffect(() => {
    setSetting(props.setting);
  }, [props.setting]);
  return (
    <>
      <Modal.Header title="Settings" hideButtonEnabled={false} />

      <Modal.Body className="temp-setting-body">
        <div className="temp-first">
          <label>Show Temperature Info:</label>
          <SwitchButton
            isOn={setting.showTemperatureInfo}
            onToggle={(state) => {
              console.log("onSettingChanged", "onToggle", state);
              setSetting({ ...setting, showTemperatureInfo: state });
            }}
            style={{
              margin: "0px 18px 0px 10px",
            }}
          />
          {/* <label>Show Tooltip:</label>
           <SwitchButton
            isOn={setting.showTooltip}
            onToggle={(state) => setSetting({ ...setting, showTooltip: state })}
            style={{
              margin:"0px 18px 0px 10px"
            }}
          /> */}
        </div>

        <div className="temp-second">
          <label>Show Graphs :</label>

          <RadioButton
            id="allGraph"
            name="showGraph"
            label="All Graph"
            checked={setting.showGraph === EGraphType.AllGraph}
            onChange={() => setSetting({ ...setting, showGraph: EGraphType.AllGraph })}
          />

          <RadioButton
            id="avgMaxMin"
            name="showGraph"
            label="Average/Min/Max"
            checked={setting.showGraph === EGraphType.AverageMinMax}
            onChange={() => setSetting({ ...setting, showGraph: EGraphType.AverageMinMax })}
          />

          <RadioButton
            id="sensorAvg"
            name="showGraph"
            label="Sensor and Average"
            checked={setting.showGraph === EGraphType.SensorAverage}
            onChange={() => setSetting({ ...setting, showGraph: EGraphType.SensorAverage })}
          />

          <RadioButton
            id="avgOutput"
            name="showGraph"
            label="Average and Output"
            checked={setting.showGraph === EGraphType.AverageOutput}
            onChange={() => setSetting({ ...setting, showGraph: EGraphType.AverageOutput })}
          />
        </div>

        <div className="temp-third">
          <InputNumber
            label="Min Temp"
            value={setting.minTemp}
            onChange={(value) => setSetting({ ...setting, minTemp: value })}
            unit="&deg;C"
            min={-5}
            max={setting.maxTemp - 6}
          />

          <InputNumber
            label="Max Temp"
            value={setting.maxTemp}
            onChange={(value) => setSetting({ ...setting, maxTemp: value })}
            unit="&deg;C"
            min={setting.minTemp + 6}
            max={100}
          />

          <InputNumber
            label="Min Output"
            value={setting.minOutput}
            onChange={(value) => setSetting({ ...setting, minOutput: value })}
            unit="%"
            min={-150}
            max={setting.maxOutput - 1}
          />

          <InputNumber
            label="Max Output"
            value={setting.maxOutput}
            onChange={(value) => setSetting({ ...setting, maxOutput: value })}
            unit="%"
            min={setting.minOutput + 1}
            max={150}
          />

          <InputNumber
            label="Refresh Interval"
            value={setting.refreshInterval}
            unit="min(s)"
            min={1}
            max={100}
            onChange={(value) => setSetting({ ...setting, refreshInterval: value })}
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        onClickOk={() => props.okHandler(setting)}
        onClickCancel={() => {
          setSetting(props.setting);
          props.cancelHandler();
        }}
      />
    </>
  );
}

type InputNumberProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  unit: string;
  min: number;
  max: number;
};

const InputNumber = ({ label, value, onChange, unit, min, max }: InputNumberProps) => {
  return (
    <div className="input-number">
      <label>{label}</label>
      <div className="input-container">
        <SpinnerTextBox
          disabled={false}
          value={value}
          onValueChanged={onChange}
          step={1}
          style={{
            width: 76,
            height: 34,
            marginRight: 5,
          }}
          min={min}
          max={max}
        />
        <div
          style={{
            lineHeight: "34px",
          }}
        >
          {unit}
        </div>
      </div>
    </div>
  );
};
